import { withInstall } from '@ll-plus/utils'

import Drawer from './src/drawer.vue'

export const LlNewDrawer = withInstall(Drawer)

export default LlNewDrawer

export * from './src/drawer'

declare module 'vue' {
  export interface GlobalComponents {
    LlNewDrawer: typeof Drawer
  }
}
